export default "__VITE_ASSET__83e000e2__"